import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

const ScriptLoader = ({ src, id, onLoad }) => {
  const handleChangeClientState = (_, { scriptTags }) => {
    if (scriptTags) {
      const script = scriptTags.find(tag => tag.id === id);
      if (script) {
        script.addEventListener('load', onLoad);
      }
    }
  };
  return (
    <Helmet onChangeClientState={handleChangeClientState}>
      <script async id={id} src={src}></script>
    </Helmet>
  );
};

ScriptLoader.propTypes = {
  src: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  onLoad: PropTypes.func.isRequired
};

export default ScriptLoader;
